<template>
  <q-layout view="hHh Lpr lfr">
    <q-header elevated class="bg-green-vito" id="top-banner">
      <q-toolbar>
        <router-link to="/">
          <q-img
            src="/img/logo.png"
            style="
              height: 120px;
              width: 230px;
              margin-left: -12px;
              margin-right: 12px;
            "
            alt="Vitogaz Logo"
          />
        </router-link>
        <q-btn
          flat
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
        />

        <q-toolbar-title id="lg-tool-bar-title" class="text-uppercase">
          {{ $t($store.state.title) }}
        </q-toolbar-title>

        <!--q-input
          outlined
          dense
          v-model="search"
          bg-color="teal-1"
          class="q-mr-md gt-xs top-search-input text-body1"
          placeholder="Parc, client, commande"
          @keydown.enter="handleSearch"
        >
          <template v-slot:prepend>
            <q-icon v-if="search === ''" name="search" />
            <q-icon
              v-else
              name="clear"
              class="cursor-pointer"
              @click="search = ''"
            />
          </template>
        </q-input-->

        <q-avatar
          size="60px"
          color="red-vito"
          class="q-ml-auto q-mr-sm cursor-pointer"
        >
          {{ nameLetter }}
          <q-menu anchor="bottom right" self="top right" auto-close>
            <q-item clickable @click="editProfileOpen = true">
              <q-icon name="manage_accounts" size="sm" class="q-mr-sm" />
              <q-item-section>{{ $t("button.myProfile") }}</q-item-section>
            </q-item>
            <q-item clickable @click="logout">
              <q-icon name="logout" size="sm" class="q-mr-sm" />
              <q-item-section>{{ $t("button.logOut") }}</q-item-section>
            </q-item>
          </q-menu>
        </q-avatar>
      </q-toolbar>
    </q-header>

    <q-drawer
      v-model="leftDrawerOpen"
      show-if-above
      class="bg-grey-7"
      :width="230"
    >
      <q-img
        src="/img/logo.png"
        style="height: 120px; width: 230px"
        class="lt-md"
      />
      <!--q-input
        outlined
        dense
        square
        v-model="search"
        class="bg-grey-2 q-mt-md q-mx-md lt-sm top-search-input"
        placeholder="Parc, client, commande"
        @keydown.enter="
          leftDrawerOpen = false;
          handleSearch();
        "
      >
        <template v-slot:prepend>
          <q-icon v-if="search === ''" name="search" />
          <q-icon
            v-else
            name="clear"
            class="cursor-pointer"
            @click="search = ''"
          />
        </template>
      </q-input-->

      <q-list dark class="text-white q-mt-lg" style="overflow: hidden">
        <q-item clickable to="/" active-class="text-white">
          <q-item-section avatar>
            <q-icon name="home" />
          </q-item-section>
          <q-item-section>
            <q-item-label>{{ $t("button.dashboard") }}</q-item-label>
          </q-item-section>
        </q-item>

        <q-expansion-item
          icon="miscellaneous_services"
          :label="$t('button.management')"
          default-opened
        >
          <q-item
            clickable
            to="/orders"
            active-class="text-white"
            :class="orderClass"
          >
            <q-item-section avatar>
              <q-icon name="shopping_cart" class="q-ml-md" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="q-ml-md">{{
                $t("button.orders")
              }}</q-item-label>
            </q-item-section>
          </q-item>

          <q-item
            clickable
            to="/stores"
            active-class="text-white"
            :class="storeClass"
          >
            <q-item-section avatar>
              <q-icon name="apps" class="q-ml-md" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="q-ml-md">{{
                $t("button.stores")
              }}</q-item-label>
            </q-item-section>
          </q-item>

          <q-item
            v-if="isAdmin"
            clickable
            to="/contracts"
            active-class="text-white"
            :class="contractClass"
          >
            <q-item-section avatar>
              <q-icon name="assignment" class="q-ml-md" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="q-ml-md">{{
                $t("button.contracts")
              }}</q-item-label>
            </q-item-section>
          </q-item>

          <q-item clickable to="/products" active-class="text-white" v-if="isAdmin">
            <q-item-section avatar>
              <q-icon name="settings" class="q-ml-md" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="q-ml-md">{{
                $t("button.products")
              }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-expansion-item>

        <q-expansion-item
          v-if="isAdmin"
          icon="construction"
          :label="$t('button.system')"
          :default-opened="systemOpened"
        >
          <q-item clickable to="/users" active-class="text-white">
            <q-item-section avatar>
              <q-icon name="manage_accounts" class="q-ml-md" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="q-ml-md">{{
                $t("button.users")
              }}</q-item-label>
            </q-item-section>
          </q-item>

          <q-item
            clickable
            to="/visits"
            active-class="text-white"
            :class="visitClass"
          >
            <q-item-section avatar>
              <q-icon name="engineering" class="q-ml-md" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="q-ml-md">{{
                $t("button.interventions")
              }}</q-item-label>
            </q-item-section>
          </q-item>

          <q-item
            clickable
            to="/logs/orders"
            active-class="text-white"
            :class="logsClass"
          >
            <q-item-section avatar>
              <q-icon name="history" class="q-ml-md" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="q-ml-md">{{
                $t("button.logs")
              }}</q-item-label>
            </q-item-section>
          </q-item>

          <q-item clickable to="/docs" active-class="text-white">
            <q-item-section avatar>
              <q-icon name="auto_stories" class="q-ml-md" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="q-ml-md">{{
                $t("button.documentation")
              }}</q-item-label>
            </q-item-section>
          </q-item>

          <q-item
            clickable
            to="/admin/general"
            active-class="text-white"
            :class="settingsClass"
          >
            <q-item-section avatar>
              <q-icon name="tune" class="q-ml-md" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="q-ml-md">{{
                $t("button.settings")
              }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-expansion-item>
      </q-list>
    </q-drawer>

    <q-dialog v-model="editProfileOpen" ref="editProfileDialog">
      <profile
        v-on:logout="logout"
        v-on:hide="editProfileOpen = false"
        v-on:shake="$refs.editProfileDialog.shake()"
      />
    </q-dialog>

    <q-page-container>
      <q-scroll-area
        :thumb-style="thumbStyle"
        style="height: calc(100vh - 120px); width: 100%"
        class="bg-grey-1"
      >
        <router-view />
      </q-scroll-area>
    </q-page-container>
  </q-layout>
</template>

<script>
import Profile from "../components/Profile.vue";
import AuthApi from "../apis/Auth";
import { useI18n } from "vue-i18n";
import ParamApi from "../apis/Param";

export default {
  name: "LayoutDefault",
  components: {
    Profile,
  },
  setup() {
    const { locale } = useI18n({ useScope: "global" });
    return {
      locale,
    };
  },
  data: () => {
    return {
      editProfileOpen: false,
      leftDrawerOpen: false,
      search: "",
      nameLetter: "?",

      thumbStyle: {
        right: "0px",
        borderRadius: "5px",
        backgroundColor: "rgb(0, 96, 86)",
        width: "10px",
        opacity: 0.55,
        previousRoutePath: null,
      },
      activeItemClass: "q-router-link--exact-active",
    };
  },
  async mounted() {
    try {
      const globalParamsResponse = await ParamApi.findAll();
      const currency = globalParamsResponse.data.currency;
      if (currency) {
        this.$store.commit("setCurrency", currency);
      }
      if (!this.$store.getters.currency) {
        //console.log("Currency not found");
        this.$store.commit("setCurrency", "CHF");
      }
      const profileResponse = await AuthApi.profile();
      // On an expired session the API interceptor resolves with the 401
      // response instead of rejecting: don't treat it as a valid profile.
      if (
        !profileResponse ||
        profileResponse.status === 401 ||
        !profileResponse.data ||
        !profileResponse.data.name
      ) {
        this.logout();
        return;
      }
      this.$store.commit("setUser", profileResponse.data);
      if (profileResponse.data.language) {
        this.locale = profileResponse.data.language;
      }
      this.nameLetter = this.$store.getters.userName.substring(0, 1);
    } catch (error) {
      if (error.response && error.response.data.statusCode == 401) {
        console.error(error.response.data.message);
        this.logout();
      } else {
        console.error(error);
      }
    }
  },
  methods: {
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.previousRoutePath = from.path;
      });
    },
    handleSearch() {
      console.log("searching...");
    },
    logout() {
      localStorage.removeItem("token");
      this.$store.commit("setToken", null);
      this.$store.commit("setUser", null);
      this.$router.push(
        this.previousRoutePath
          ? "/login?redirect=" + this.previousRoutePath
          : "/login"
      );
    },
  },
  computed: {
    contractClass() {
      return this.$route.fullPath.slice(0, 10) == "/contract/"
        ? this.activeItemClass
        : "";
    },
    storeClass() {
      return this.$route.fullPath.slice(0, 7) == "/store/"
        ? this.activeItemClass
        : "";
    },
    orderClass() {
      return this.$route.fullPath.slice(0, 7) == "/order/"
        ? this.activeItemClass
        : "";
    },
    settingsClass() {
      return this.$route.fullPath.slice(0, 7) == "/admin/"
        ? this.activeItemClass
        : "";
    },
    logsClass() {
      return this.$route.fullPath.slice(0, 6) == "/logs/"
        ? this.activeItemClass
        : "";
    },
    visitClass() {
      return this.$route.fullPath.slice(0, 7) == "/visit/"
        ? this.activeItemClass
        : "";
    },
    systemOpened() {
      return ["/user", "/inte", "/logs", "/docs", "/admi", "/visi"].includes(
        this.$route.fullPath.slice(0, 5)
      );
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
};
</script>

<style scoped>
.q-drawer .q-router-link--exact-active::before {
  content: "";
  position: absolute;
  left: 230px;
  display: block;
  border-top: 0px solid transparent;
  border-right: 0px solid transparent;
  border-left: 10px solid #fafafa;
  border-bottom: 10px solid #fafafa;
  width: 10px;
  height: 10px;
  transform: translate(-5px, 12px) rotate(45deg);
}
.q-drawer__content {
  overflow-x: hidden !important;
}
</style>
